import { css } from "@emotion/react";
import { memo, useEffect, useState } from "react";
import {
  useAccount,
  useContractEvent,
  useNetwork,
  useWaitForTransaction,
} from "wagmi";
import * as _wagmi_core from "@wagmi/core";
import { yakoContract } from "../../pages/MintPage";

interface StatusPopupProps {
  publicMintData?: _wagmi_core.SendTransactionResult | undefined;
  allowlistMintData?: _wagmi_core.SendTransactionResult | undefined;
  publicMintError: Error | null;
  allowlistMintError: Error | null;
  publicClaimed: any;
  whitelistClaimed: any;
  isPublicMintOpen: boolean;
}

const text = {
  idle: {
    title: "",
    text: "",
  },
  loading: {
    title: "Please Wait …",
    text: "Please continue to wait at the same screen.",
  },
  success: {
    title: "Success",
    text: "",
  },
  error: {
    title: "Failed",
    text: "Please reload the app and try again",
  },
};

const link = {
  etherscan: {
    main: "https://etherscan.io/tx/",
    goelri: "https://goerli.etherscan.io/tx/",
  },
  opensea: {
    main: `https://opensea.io/assets/ethereum/${process.env.REACT_APP_CONTRACT_ADDRESS}/`,
    goelri: `https://testnets.opensea.io/assets/goerli/${process.env.REACT_APP_CONTRACT_ADDRESS}/`,
  },
};

const StatusPopup: React.FC<StatusPopupProps> = ({
  publicMintData,
  allowlistMintData,
  publicMintError,
  allowlistMintError,
  whitelistClaimed,
  publicClaimed,
  isPublicMintOpen,
}) => {
  const { address } = useAccount();
  const { chain } = useNetwork();
  const [open, setOpen] = useState(false);
  const [type, setType] = useState<"success" | "error" | "loading" | "idle">(
    "idle"
  );
  const [tokenId, setTokenId] = useState("");
  const [minted, setMinted] = useState(false);
  useContractEvent({
    ...yakoContract,
    eventName: "Transfer",
    listener(from, to, id) {
      console.log("Transfer", from, to, id);
      if (to === address) {
        setType("success");
        setMinted(true);
        setTokenId(id.toNumber());
      }
    },
  });

  const {
    data: waitTransactionData,
    isError,
    isLoading,
  } = useWaitForTransaction({
    hash: publicMintData
      ? publicMintData?.hash
      : allowlistMintData
      ? allowlistMintData?.hash
      : undefined,
  });

  console.log("waitTransactionData", waitTransactionData);

  useEffect(() => {
    if (minted) {
      return;
    }
    if (!isLoading && !isError) {
      return;
    }

    if (isLoading) {
      setType("loading");
      setOpen(true);
    }

    if (isError) {
      setType("error");
      setOpen(true);
    }
  }, [isError, isLoading, minted]);

  // useEffect(() => {
  //   if (whitelistClaimed && allowlistMintError !== null) {
  //     return;
  //   }
  //   if (publicClaimed && publicMintError !== null) {
  //     return;
  //   }
  //   if (!isPublicMintOpen && publicMintError !== null) {
  //     return;
  //   }
  //   if (!isPublicMintOpen && allowlistMintError !== null) {
  //     return;
  //   }
  //   if (isPublicMintOpen && allowlistMintError !== null) {
  //     return;
  //   }
  //   if (allowlistMintError !== null || publicMintError !== null) {
  //     setType("error");
  //     setOpen(true);
  //   }
  // }, [allowlistMintError, publicMintError]);

  return open ? (
    <div
      css={[
        css`
          position: fixed;
          top: 0;
          right: 0;
          bottom: 0;
          left: 0;
          z-index: 9999;
          display: flex;
          align-items: center;
          justify-content: center;
          background-color: rgba(0, 0, 0, 0.8);
        `,
      ]}
    >
      <div
        css={css`
          width: 60%;
          max-width: 400px;
          padding: 16px;
          background-color: #fff;
          @media screen and (max-width: 1024px) {
            width: 90%;
          }
        `}
      >
        <div
          css={css`
            padding-bottom: 0.8em;
            text-align: center;
            text-transform: uppercase;
          `}
        >
          <h3
            css={css`
              padding-bottom: 0.4em;
              font-weight: 900;
            `}
          >
            {`${text[type].title}`}
          </h3>
          {type === "loading" && <div className="loader">Loading...</div>}
          <p
            css={css`
              line-height: 1.2;
              padding-bottom: 8px;
            `}
          >
            {`${text[type].text}`}
          </p>
          {type === "success" && (
            <img
              css={css`
                max-width: 80%;
                margin: 0 auto 20px;
              `}
              src="/icon_s.png"
              alt=""
            />
          )}
          <div
            css={css`
              display: flex;
              justify-content: center;
              align-items: center;
              @media screen and (max-width: 1024px) {
                flex-direction: column;
                gap: 4px;
              }
            `}
          >
            {(type === "loading" || type === "success") && (
              <button
                css={css`
                  border: 1px solid #e63c3c;
                  border-radius: 3px;
                  color: #e63c3c;
                  text-transform: uppercase;
                  padding: 2px 16px;
                  background-color: #fff;
                  cursor: pointer;
                  transition: 0.3s;
                  width: 49%;
                  margin: 0 auto;
                  @media screen and (max-width: 1024px) {
                    width: 100%;
                  }

                  &:hover {
                    opacity: 0.6;
                  }
                `}
                onClick={() => {
                  window.open(
                    `${
                      link.etherscan[`${chain?.id === 5 ? "goelri" : "main"}`]
                    }${
                      publicMintData
                        ? publicMintData?.hash
                        : allowlistMintData
                        ? allowlistMintData?.hash
                        : undefined
                    }`,
                    "_blank",
                    "norefferer"
                  );
                }}
              >
                Etherscan
              </button>
            )}
            {type === "success" && (
              <button
                css={css`
                  border: 1px solid #e63c3c;
                  border-radius: 3px;
                  color: #e63c3c;
                  text-transform: uppercase;
                  padding: 2px 16px;
                  background-color: #fff;
                  cursor: pointer;
                  transition: 0.3s;
                  width: 49%;
                  @media screen and (max-width: 1024px) {
                    width: 100%;
                  }

                  &:hover {
                    opacity: 0.6;
                  }
                `}
                onClick={() => {
                  window.open(
                    `${
                      link.opensea[`${chain?.id === 5 ? "goelri" : "main"}`]
                    }${tokenId}`,
                    "_blank",
                    "noreferrer"
                  );
                }}
              >
                Opensea
              </button>
            )}
          </div>
          {(type === "success" || type === "error") && (
            <div
              css={css`
                display: flex;
                justify-content: center;
                align-items: center;
                padding-top: 8px;
              `}
            >
              <button
                css={css`
                  background-color: #e63c3c;
                  color: #fff;
                  border: none;
                  border-radius: 3px;
                  width: 100%;
                  padding: 2px 16px;
                  transition: opacity 0.3s;
                  cursor: pointer;
                  &:hover {
                    opacity: 0.6;
                  }
                `}
                onClick={() => {
                  // eslint-disable-next-line no-restricted-globals
                  location.reload();
                }}
              >
                {type === "success" ? "OK" : "Reload"}
              </button>
            </div>
          )}
        </div>
      </div>
    </div>
  ) : null;
};

export default memo(StatusPopup);
